import { Injectable } from '@angular/core';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
import { HomeUsecase } from '@domain/usecases/home/home-usecase';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeController {
  constructor(private usecaseService: HomeUsecase) {}

  get(): Observable<CidadeEntity> {
    return this.usecaseService.get();
  }
}
